import React from "react";

import Table from "../../common/Table";

import { Link } from "react-router-dom";

const FinanceClassListTable = ({ data, match, query }) => {
  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "class_desc",
      label: "نام صنف",
      content: (e) => (
        <Link
          to={`/mis/students/fees/faculties/${match.params.fid}/classes/${e.class_id}`}
        >
          {e.class_desc}
        </Link>
      ),
    },
    { path: "student_count", label: "تعداد محصل" },
    { path: "payable", label: "قابل پرداخت" },
    { path: "discount", label: "تخفیف" },
    { path: "paid", label: "پرداخت شده" },
    { path: "balance", label: "باقیمانده" },
    { path: "current_overall_balance", label: "مجموع باقیمانده" },
    { path: "option" },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default FinanceClassListTable;
